var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-amap-container"},[_c('div',{staticClass:"l-amap",attrs:{"id":_vm.mapId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }